import ProductInfoList from '@/data/productInfo/view/list.vue'
import ProductInfoEditor from '@/data/productInfo/view/editor.vue'

const list = {
  path: '/productInfo',
  name: 'productInfo-list',
  component: ProductInfoList
}
const creator = {
  path: '/productInfo/creator',
  name: 'createProductInfo',
  component: ProductInfoEditor
}
const editor = {
  path: '/productInfo/editor/:id(\\d+)',
  name: 'updateProductInfo',
  component: ProductInfoEditor
}

export default [list, creator, editor]
